<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import TrafficRecordComponents from "@/components/traffic-record-components.vue"

export default {
  page: {
    title: "Approval",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Approval",
      items: [
        {
          text: "Home",
        },
         {
          text: "LGU",
        },  
        {
          text: "Approval",
          active: true,
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
    TrafficRecordComponents
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <TrafficRecordComponents phase-id="4" />
  </Layout>
</template>